// extracted by mini-css-extract-plugin
export default {"user-container":"client-components-mapPortal-drawerContent-bulkCreateModal-formView-body-general-___userSelectField__user-container___1RLaW"};